<template>
  <div>
    <div class="edit-info" v-if="!edit_form" @click="showEditTips"><span class="edit-info-icon">i</span>提交后不允许修改，如有疑问请联系出题人</div>
    <div class="enroll-info" v-if="type == 'doPage' && showUpdateAlias">
      <div class="new-box" @click="catchSubmit ? showEditTips() : ''">
        <div class="left">昵称<label class="star">*</label></div>
        <input 
          type='text'
          class='form-control' 
          :style="{ color: catchSubmit ? '#999' : '' }"
          placeholder-style='color:#ccc;' 
          @input="handleInputChange($event, 0, true)"
          maxlength="30" 
          v-model="enroll_alias" 
          :disabled="catchSubmit" 
          placeholder="请输入昵称" 
          />
          <div v-if="catchSubmit" class="cover-disable"></div>
      </div>
    </div>
    <div class="enroll-info" v-if="cameraItem">
      <div class="new-box camera-box">
        <div class="left">
          {{ cameraItem.field_name
          }}<label v-if="cameraItem.require" class="star">*</label>
        </div>
        <div class="upload-box">
          <div v-if="cameraItem.field_value" class="pic-item">
            <img
              :src="cameraItem.field_value"
              class="picture"
              @click="previewImage(cameraItem.field_value)"
            />
            <div class="delete-pic" @click="deletePic">
              删除
            </div>
          </div>
          <div class="custom-uploader" @click="openCamera('pre')" v-else>
            <div class="pic-item">
              <img :src="coverImg" class="pic" />
              <span class="desc">拍照</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="enroll-info" v-for="(item, index) in tmpItems" :key="index" @click="(catchSubmit && item.disable) || (assign_roll == 2 && item.disable) ? showEditTips() : ''">
        <template v-if="item.status && item.field_type !== 12">
          <!-- 文本 -->
          <div v-if="item.field_type === 0" class="new-box">
            <div class="left">
              {{ item.field_name
              }}<label v-if="item.require" class="star">*</label>
            </div>
            <input
              type="text"
              class="form-control"
              :style="{ color: item.disable ? '#999' : '' }"
              :maxlength="item.field_name === '姓名' ? '30' : '500'"
              v-model="item.field_value"
              :disabled="item.disable"
              :placeholder="
                item.field_desc ? item.field_desc : '请输入' + item.field_name
              "
              @input="handleInputChange($event, index)"
            />
            <div v-if="item.disable" class="cover-disable"></div>
          </div>

          <div v-if="item.field_type === 13" class="new-box" @click="(catchSubmit && item.disable) || (assign_roll == 2 && item.disable) ? showEditTips() : ''">
            <div class="left">
              {{ item.field_name
              }}<span v-if="item.require" class="star">*</span>
            </div>
            <input
              type="number"
              :style="{ color: phoneDisable || item.disable ? '#999' : '' }"
              :disabled="phoneDisable || item.disable"
              class="form-control"
              maxlength="30"
              v-model="item.field_value"
              :placeholder="
                item.field_desc ? item.field_desc : '请输入' + item.field_name
              "
              @input="handleInputChange($event, index)"
            />
            <div v-if="phoneDisable || item.disable" class="cover-disable"></div>
          </div>

          <div v-if="item.field_type == 1" class="new-box">
            <div class="left">
              {{ item.field_name
              }}<span v-if="item.require" class="star">*</span>
            </div>
            <div
              class="form-control pickers"
              @click="
                pickchoose(index, item)
              "
            >
              <span :style="{ color: item.disable ? '#999' : '' }" v-if="item.field_value">{{ item.field_value }}</span>
              <span style="color: #999999;" v-else>点击选择</span>
              <img
                class="arrow"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="currentOpt"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup
      z-index="90"
      @closed="closeModal"
      v-model="showPreModal"
      position="bottom"
      duration="0.1"
      :style="{ borderRadius: '4px 4px 0 0', background: 'transparent' }"
    >
      <Camera
        @handleShoot="handleShoot"
        @closeClick="closeClick"
        @reTake="reTake"
        @upload="upload"
        :cutUrl="cutUrl"
      />
    </van-popup>
    <video
      v-if="!showPreModal"
      style="width: 100%; height: calc(100vh - 165px);"
      class="videoEl-copy"
      muted
      playsinline
    ></video>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="settingSrc" :title="title" />
    </van-popup>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog } from "vant";
import {
  getToken,
  reLogin,
  isWeixin,
  isMobile,
  getWxUrl,
  getDetailWxCode
} from "@/utils/common";
import { deepClone } from "../utils/common";
import uploadHttp from "@/utils/picOnly";
import api from "@/utils/api";
import Vue from "vue";
import * as imageConversion from "image-conversion";
import { ImagePreview } from "vant";
import ImgDialog from "@/components/common/imgDialog.vue";
import Camera from "@/components/common/camera.vue";

export default {
  props: {
    type: {
      type: String,
      default: ""
    },
    fill_name: {
      type: String,
      default: ""
    },
    has_joined: {
      type: Number,
      value: 0
    },
    show_meet: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      cameraItem: null,
      showVersionTip: false,
      settingSrc: "",
      settingUrl: "",
      title: ["无可拍摄设备", "请使用手机扫码，到小程序操作"],
      showPreModal: false,
      tmpItems: [],
      formItems: [],
      currentI: 0,
      currentOpt: [],
      value: "",
      showPicker: false,
      qid: "",
      unionid: "",
      phoneDisable: false,
      coverImg:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-04-15/c1bac5721a0cfa68ef8cea2b7d239649.svg",
      timer: null,
      MediaStreamTrack: "",
      cutUrl: "",
      canvas: "",
      errMsg: "",
      sideErrMsg: "",
      canvas: "",
      isInApp: wemeet.app.isTMWebview(),
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      edit_form: 0,
      catchSubmit: false,
      showUpdateAlias: false,
      enroll_alias: ''
    };
  },
  mounted() {
    this.qid = this.$route.query.qid;
    this.unionid = this.$route.query.unionid;
    if(this.fill_name) {
      this.enroll_alias = this.fill_name;
      this.enroll_alias_ori = this.fill_name;
    }
    this.getRegInfo();
  },
  methods: {
    pickchoose(index, item) {
      if(this.catchSubmit && item.disable) {
        return;
      }
      this.showPicker = true;
      this.currentI = index;
      this.currentOpt = item.options;
    },
    showEditTips() {
      Dialog.confirm({
        title: "",
        message: this.catchSubmit ? '出题人已设置，不允许修改已填写信息。请给出题人留言说明情况' : "指定名单信息不允许修改，若内容有误，请给发起人留言说明情况",
        cancelButtonText: "我知道了",
        confirmButtonColor: "#1890ff",
        cancelButtonColor: '#999999',
        confirmButtonText: this.type == 'doPage' ? "我知道了" : "去留言",
        showCancelButton: this.type == 'doPage' ? false : true
      })
        .then(() => {
          if(this.type != 'doPage') {
            this.handleCameraError(1);
          }
        })
        .catch(() => {});
    },
    handleShoot(e) {
      this.cutUrl = e.url;
      this.canvas = e.canvas;
      this.closeCamera();
    },
    closeClick() {
      this.closeCamera();
      this.showPreModal = false;
      this.cutUrl = "";
    },
    closeModal() {
      this.closeCamera();
      this.cutUrl = "";
    },
    closeCamera() {
      this.MediaStreamTrack && this.MediaStreamTrack.stop();
    },
    openCamera(pre) {
      if(this.catchSubmit && this.cameraItem.field_value) return;
      this.$store.commit("changeLoading", { status: true, text: "loading" });
      this.checkCamera(pre);
    },
    async checkCamera(pre) {
      let _this = this;
      try {
        if (window.navigator.mediaDevices == undefined) {
          window.navigator.mediaDevices = {};
        }
        const navigator = window.navigator;
        // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
        // 因为这样可能会覆盖已有的属性。这里我们只会在没有 getUserMedia 属性的时候添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function(constraints) {
            // 首先，如果有 getUserMedia 的话，就获得它
            var getUserMedia =
              navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

            // 一些浏览器根本没实现它 - 那么就返回一个 error 到 promise 的 reject 来保持一个统一的接口
            if (!getUserMedia) {
              return Promise.reject(
                new Error("getUserMedia is not implemented in this browser")
              );
            }
            // 否则，为老的 navigator.getUserMedia 方法包裹一个 Promise
            return new Promise(function(resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          };
        }
        navigator.mediaDevices
          .getUserMedia({ audio: false, video: true })
          .then(stream => {
            if (pre) {
              _this.showPreModal = true;
            }
            setTimeout(() => {
              // ai的解释：
              // elist.vue 中额外放了一个 video (class="videoEl-copy") 并把它移到屏幕外，是作为占位的“备选”节点：当未打开拍照弹窗时，也能把浏览器返回的 MediaStream 先挂到一个 <video> 上，完成权限申请/预览流的占用。
              // camera.vue 的 <video ref="videoEl"> 是弹窗内真正给用户看的预览，它在用户点击“拍照”后显示，并被用于截图到 canvas，再上传。
              // 优先绑定弹窗里的摄像头预览 video，找不到时再退回到隐藏的占位 video
              var video = document.querySelector(".videoEl") || document.querySelector(".videoEl-copy");
              // 旧的浏览器可能没有 srcObject
              if ("srcObject" in video) {
                video.srcObject = stream;
              } else {
                // 防止在新的浏览器里使用它，应为它已经不再支持了
                video.src = window.URL.createObjectURL(stream);
              }
              video.play();
              this.MediaStreamTrack =
                typeof stream.stop === "function"
                  ? stream
                  : stream.getTracks()[0];
              video.onloadedmetadata = function(e) {
                video.play();
                _this.$store.commit("changeLoading", { status: false });
              };
            }, 10);
          })
          .catch(err => {
            this.$store.commit("changeLoading", { status: false });
            this.errMsg = err;
            if (err == "NotAllowedError: Requested device not found") {
              // 该设备不支持
              this.handleCameraError();
            } else if (
              err == "NotAllowedError: Permission denied" ||
              err ==
                "NotAllowedError: The request is not allowed by the user agent or the platform in the current context."
            ) {
              // 关闭了权限
              Dialog.confirm({
                title: "",
                message: "摄像头未授权, 请前往设置页开启授权或前往小程序拍照",
                cancelButtonText: "我知道了",
                confirmButtonColor: "#1890ff",
                confirmButtonText: "前往小程序"
              })
                .then(() => {
                  this.handleCameraError();
                })
                .catch(() => {});
            } else {
              this.handleCameraError();
            }
          });
      } catch (err) {
        if (pre) {
          this.handleCameraError();
        }
        this.$store.commit("changeLoading", { status: false });
      }
    },
    async handleCameraError(type) {
      // 摄像头不可用处理 pc展示二维码 h5直接跳转小程序
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        this.title = type ? ['H5版本暂不支持', '请使用手机扫码，到小程序操作'] :["无可拍摄设备", "请使用手机扫码，到小程序操作"]
        if (!this.settingSrc) {
          this.settingSrc = await getDetailWxCode(this.qid);
        }
        this.showVersionTip = true;
      }
    },
    // 重拍
    async reTake() {
      if (!this.cutUrl) return;
      // 假设这里有一个异步操作更改 cutUrl
      await new Promise(resolve => {
        // 异步操作代码，完成后调用 resolve
        // 比如模拟一个异步请求
        setTimeout(() => {
          this.$store.commit("changeLoading", {
            status: true,
            text: "loading"
          });
          this.cutUrl = null;
          this.checkCamera();
          resolve();
        }, 5);
      });
    },
    // 拍到的图片upload
    upload() {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      this.canvas.toBlob(blob => {
        try {
          var url = api.question.upload;
          let formData = new window.FormData();
          formData.append("file", blob);
          formData.append("access_token", getToken());
          uploadHttp.post(url, formData).then(res => {
            Vue.set(this.tmpItems, 0, {
              ...this.tmpItems[0],
              field_value: res.data.urls[0]
            });
            Vue.set(this.cameraItem, 'field_value', res.data.urls[0]);
            this.showPreModal = false;
            this.$store.commit("changeLoading", { status: false });
          });
        } catch (e) {
          this.$store.commit("changeLoading", { status: false });
        }
      });
    },
    handleInputChange(e, index, alias) {
      if(alias) {
        this.enroll_alias = e.target.value;
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        Vue.set(this.tmpItems, index, {
          ...this.tmpItems[index],
          field_value: e.target.value
        });
        // 在这里可以处理节流后的输入框值变化
      }, 500);
    },
    deletePic() {
      if(this.catchSubmit && this.cameraItem.disable) return;
      Vue.set(this.tmpItems, 0, {
        ...this.tmpItems[0],
        field_value: "",
        imgList: []
      });
      Vue.set(this.cameraItem, 'field_value', '');
    },
    previewImage(val) {
      ImagePreview({
        images: [val],
        closeable: true,
        startPosition: 0
      });
    },
    beforeRead(file) {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      const isLt1M = (file.size / 1024 / 1024) * 10 < 5;
      if (!isLt1M) {
        let myImg = new Promise(resolve => {
          // 压缩到500KB,这里的500就是要压缩的大小,可自定义
          imageConversion.compressAccurately(file, 500).then(res => {
            resolve(res);
          });
        });
        return myImg;
      }
      return true;
    },
    afterRead(file) {
      var url = api.question.upload;
      let formData = new window.FormData();
      formData.append("file", file.file);
      formData.append("access_token", getToken());
      try {
        uploadHttp.post(url, formData).then(res => {
          Vue.set(this.tmpItems, 0, {
            ...this.tmpItems[0],
            field_value: res.data.urls[0],
            imgList: [res.data.urls[0]]
          });
          this.$store.commit("changeLoading", { status: false });
        });
      } catch (e) {
        this.$store.commit("changeLoading", { status: false });
      }
    },
    addImg() {},
    getRegInfo() {
      let param = {
        qid: this.qid,
        unionid: this.unionid,
        access_token: getToken(),
        version_code: 1,
        xcx_version: "1.0.0"
      };
      questionOnly.get("/xcx/ques/v2/reginfo", param).then(res => {
        if (res.sta == 0) {
          // 直接全部清空
          let {
            reg_params,
            assign_roll,
            alias,
            input_status,
            org_rule,
            phone,
            edit_form
          } = res.data;
          this.assign_roll = assign_roll;
          this.input_status = input_status;
          this.edit_form = edit_form 
          this.catchSubmit = !edit_form && ((reg_params && reg_params.length) || this.type == 'doPage') ? true : false;
          if(this.type == 'doPage' && this.has_joined == 0) {
            this.catchSubmit = false;
          }
          this.ori_reg_params = deepClone(reg_params);
          var req_info = [...res.data.reg_info] || [];
          if (reg_params && reg_params.length > 0) {
            let nameIndex = reg_params.findIndex(item => item.field_key == 1);
            if (
              nameIndex > -1 &&
              reg_params[nameIndex].field_value &&
              assign_roll == 2
            ) {
              reg_params[nameIndex].field_value = alias;
              if (!input_status) {
                let reg_name_index = req_info.findIndex(
                  item => item.field_key == 1
                );
                if (reg_name_index > -1) {
                  req_info[reg_name_index].disable = true;
                }
                if (org_rule == 1) {
                  this.phoneDisable = true;
                }
              }
            }
            req_info = getFormItems(req_info, reg_params, this);
            if (
              nameIndex > -1 &&
              reg_params[nameIndex].field_value &&
              !input_status
            ) {
              req_info[nameIndex].disable = true;
            }
          } else if (assign_roll == 2) {
            let reg_params_len = reg_params.length || 0;
            req_info.map((item, index) => {
              reg_params[index] = {
                field_value: item.field_key == 1 ? alias || "" : "",
                field_name: item.field_name,
                field_key: item.field_key,
                field_type: item.field_type
              };
            });
            req_info = getFormItems(req_info, reg_params, this);
            let fillIndex = reg_params.findIndex(item => item.field_key == 1);
            if (
              fillIndex > -1 &&
              reg_params[fillIndex].field_value &&
              !input_status
            ) {
              req_info[fillIndex].disable = true;
            }
            if (org_rule == 1 && phone && !reg_params_len) {
              req_info.map(item => {
                if (item.field_type == 13) {
                  item.field_value = phone;
                  if (input_status == 0) {
                    this.phoneDisable = true;
                  }
                }
              });
            }
          } else {
            this.partFill = true;
            req_info = resetEnroll(req_info);
          }
          req_info.sort((a, b) => {
            if (a.field_type === 12) {
              return -1;
            } // 将field_type为12的项放在第一个位置
            if (b.field_type === 12) {
              return 1
            };
            return 0;
          });
          if(req_info && req_info.length) {
            let findItem = req_info.find((item)=> item.field_type === 12);
            if(findItem && findItem.status) {
              this.cameraItem = req_info[0];
            }
          }
          req_info = req_info.filter((item)=> item.status)
          this.tmpItems = req_info;
          this.formItems = req_info;
          if(req_info && req_info.length) {
            if(!req_info.find((item)=> item.field_key == 1)) {
              this.showUpdateAlias = true;
            }
          }else {
            this.showUpdateAlias = true;
          }
          // 如果有名字，就塞进去
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    onConfirm(value, index) {
      Vue.set(this.tmpItems, this.currentI, {
        ...this.tmpItems[this.currentI],
        field_value: value
      });
      this.showPicker = false;
    },
    enrollData() {
      if(this.catchSubmit && !this.partFill) {
        return this.showEditTips();
      }
      var formItems = this.formItems,
        len = formItems.length,
        info = [];
      let ori_reg_params = this.ori_reg_params;
      for (var i = 0; i < len; i++) {
        var item = formItems[i],
          val = item.field_value || "";
        if (item.require && item.status) {
          if (
            item.field_type == 0 ||
            item.field_type == 13 ||
            item.field_type == 1 ||
            item.field_type == 12
          ) {
            if (!val) {
              if (item.field_type == 12) {
                Toast("请先完成人像拍照");
              } else {
                Toast("请输入或者选择" + "[" + item.field_name + "]");
              }
              return;
            }
          }
        }
        info.push({
          field_name: item.field_name,
          field_value: val,
          field_key: item.field_key,
          ...(item.field_type == 13 || item.field_type == 12
            ? { field_type: item.field_type }
            : {})
        });
      }
      if (
        this.assign_roll == 2 &&
        !this.input_status &&
        ori_reg_params.length
      ) {
        let fillIndex = info.findIndex(item => item.field_key == 1) || 0;
        let oriIndex =
          ori_reg_params.findIndex(item => item.field_key == 1) || 0;
        info[fillIndex].field_value = ori_reg_params[oriIndex].field_value;
      }

      // 对人像拍照处理
      let cameraIndex = info.findIndex(item => item.field_type == 12);
      if (cameraIndex > -1) {
        let cameraItem = info[cameraIndex];
        if (
          cameraItem.field_value &&
          cameraItem.field_value ==
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/ques_censor_tip.png"
        ) {
          // // 当前的人像拍照是审核中的图片
          let oriItem = ori_reg_params.find(item => item.field_type == 12);
          info[cameraIndex].field_value = oriItem.origin_field_value;
        }
      }
      let nameFill = '';
      if(this.type == 'doPage') {
        nameFill = this.showUpdateAlias ? this.enroll_alias : info.find((item)=> item.field_key == 1).field_value;
      }
      if(this.type == 'doPage' && this.showUpdateAlias && this.enroll_alias != this.enroll_alias_ori) {
        if(!nameFill || nameFill.match(/^小小答题.*/) || nameFill.match(/^立吉答题.*/)) {
          return Toast('请填写昵称')
        }
        this.updateProfile(nameFill);
        setTimeout(()=> {
          this.$parent.$parent.enroll(info, nameFill)
        }, 1000)
        return;
      }
      if(this.type == 'doPage') {
        this.$parent.$parent.enroll(info, nameFill)
      }else {
        this.$parent.enroll(info, nameFill)
      }
    },
    updateProfile(name) {
      let param = {
        qid: this.qid,
        name,
        sync_info: 0,
        access_token: getToken(),
        version_code: 1
      };
      questionOnly.post("/xcx/ques/v1/user/profile", param).then(res => {
        if(res.sta == 0) {
          questionOnly.post("/xcx/ques/v1/reginfo/sync", {
            qid: this.qid,
            access_token: getToken(),
            version_code: 1,
          }).then(res => {})
        }
      })
    },
  },
  components: { ImgDialog, Camera }
};

function resetEnroll(req_info) {
  for (var i = 0; i < req_info.length; i++) {
    var item = req_info[i];
    if (item.field_type <= 1) {
      item.field_value = item.field_value
        ? item.field_value
        : item.default_value || "";
    }
  }
  return req_info;
}

function getFormItems(req_info, info, self) {
  let checkCount = 0;
  var len = req_info.length,
    formItems = req_info;
  for (var i = 0; i < len; i++) {
    var item = req_info[i];
    for (var j = 0; j < info.length; j++) {
      var itemName,
        currentName,
        itemValue = info[j].field_value;
      var currentName = item.field_name;
      if (info[j].field_key) {
        itemName = info[j].field_key;
        currentName = item.field_key;
      }
      if (currentName == itemName) {
        // 文本 & 数字
        if (item.field_type <= 1) {
          if (typeof itemValue == "object") {
            itemValue = itemValue.toString();
          }
          if (!itemValue && item.default_value) itemValue = item.default_value;
        }
        item.field_value = itemValue;
        if(self.catchSubmit && item.field_value) {
          checkCount = checkCount + 1;
          item.disable = true;
        };
      }
    }
  }
  if(self.catchSubmit) {
    if(checkCount != formItems.filter((item)=> item.status).length) {
      self.partFill = true;
    }
  }
  return formItems;
}
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.enroll-info .label {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #333;
  padding: 0 15px 6px;
}

.enroll-info {
  position: relative;
  // background: #fff;
  border-radius: 4px;
}

.form-control {
  display: inline-block;
  background: #fff;
  height: 52px;
  line-height: 52px;
  flex: 1;
  font-size: 15px;
  color: #000;
  border: none;
  overflow: hidden;
  border-bottom: 1px solid #EEEEEE;
}
input::input-placeholder{
	color:#999;
}
.new-box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  padding: 0 15px;
  font-size: 15px;
  color: #000;
  min-height: 52px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 4px;
  position: relative;
}
.cover-disable {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 52px;
}

.new-box .left {
  width: 95px;
  min-width: 95px;
  overflow: hidden;
}

.btn-phone {
  font-size: 13px;
  padding: 5px;
  color: #fff;
  background-color: #1890ff;
  border-radius: 4px;
}

.star {
  color: #ff6d6d;
}

.arrow {
  width: 8px;
  height: 12.5px;
  margin-left: 10px;
}

.checkin-info-row {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  justify-content: space-between;
}

.userInfo {
  padding: 5px 15px 10px 15px;
  font-size: 13px;
  color: #999999;
}

.enroll-box {
  border-radius: 4px;
}

.arrow-delete {
  width: 15px;
  height: 15px;
  padding: 10px;
  right: -10px;
}

.right-arrow {
  width: 8px;
  height: 12px;
  margin-left: 8px;
  margin-top: 2px;
}

.show {
  display: block;
}

.hide {
  display: none;
}

.new-tip .tip {
  font-size: 12px;
  color: #999;
  padding: 0 15px;
  margin-top: 10px;
}

.new-tip .tip .icon {
  float: left;
  width: 13px;
  height: 13px;
  padding: 3px 5px 0 0;
}

.picture {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.pic-item {
  width: 60px;
  height: 60px;
  position: relative;
  background-color: #f2f2f7;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #999999;
  margin-right: 10px;
}

.pic-item:first-child {
  margin-left: 0;
}

.pic-item.active {
  width: 20px;
  height: 20px;
}

.delete-pic {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.42);
  border-radius: 0 0 2px 2px;
  color: #fff;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.pic {
  width: 30px;
  height: 30px;
}

.camera-box {
  // margin-bottom: 10px;
  padding: 15px;
  border-radius: 4px;
  // background: red;
}
.divide-line {
  height: 10px;
  background: #efeff4;
  // border-radius: 4px;
}
.upload-box {
  width: 60px;
  height: 60px;
  overflow: hidden;
  box-sizing: border-box;
}
.pickers {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .custom-uploader .van-uploader__file {
  width: 60px;
  height: 60px;
}
.videoEl-copy {
  width: 100%;
  position: absolute;
  z-index: 99;
  right: 30000px;
}
.wrap {
  background: #fff;
  border-radius: 4px;
}
.edit-info {
  font-size: 13px;
  background: #FFF1E5;
  color: #FB7417;
  height: 29px;
  display: flex;
  align-items: center;
  padding: 0 15px;
}
.edit-info-icon {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  display: inline-flex;
  background: #FB7417;
  font-size: 12px;
  color: #fff;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
input::placeholder {
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/elist.vue